module.exports = __webpack_public_path__ + "static/media/HDFC.7a2659d6.txt";